<template>
  <section id="horarios" class="horarios-layout" aria-label="Horarios y eventos">
    <HorariosList :horarios="horarios" :loading="loading" :error="error" />
    <EventosCalendario />
  </section>
</template>

<script>
import axios from "@/directives/axios.js";
import HorariosList from "./horariosSection/HorariosList.vue";
import EventosCalendario from "./horariosSection/EventosCalendario.vue";

export default {
  name: "HorariosSection",

  components: {
    HorariosList,
    EventosCalendario,
  },

  data() {
    return {
      horarios: [],
      loading: true,
      error: false,
    };
  },

  async mounted() {
    try {
      const res = await axios.get("/horario");
      this.horarios = res.data.horarios || [];
    } catch (e) {
      console.error("Error cargando horarios", e);
      this.error = true;
    } finally {
      this.loading = false;
    }
  },
};
</script>

<style scoped>
.horarios-layout {
  display: grid;
  gap: 32px;
  scroll-margin-top: 120px;
}

@media (min-width: 1100px) {
  .horarios-layout {
    grid-template-columns: minmax(0, 2fr) minmax(320px, 1fr);
    align-items: start;
  }
}
</style>
